/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BuildingOfficeFlagIcon16Light } from './BuildingOfficeFlagIcon16Light';
import { BuildingOfficeFlagIcon16Regular } from './BuildingOfficeFlagIcon16Regular';
import { BuildingOfficeFlagIcon16Solid } from './BuildingOfficeFlagIcon16Solid';
import { BuildingOfficeFlagIcon20Light } from './BuildingOfficeFlagIcon20Light';
import { BuildingOfficeFlagIcon20Regular } from './BuildingOfficeFlagIcon20Regular';
import { BuildingOfficeFlagIcon20Solid } from './BuildingOfficeFlagIcon20Solid';
import { BuildingOfficeFlagIcon24Regular } from './BuildingOfficeFlagIcon24Regular';
import { BuildingOfficeFlagIcon24Solid } from './BuildingOfficeFlagIcon24Solid';
import { BuildingOfficeFlagIcon32Regular } from './BuildingOfficeFlagIcon32Regular';
import { BuildingOfficeFlagIcon64Regular } from './BuildingOfficeFlagIcon64Regular';
var sizes = {
    16: {
        light: BuildingOfficeFlagIcon16Light,
        regular: BuildingOfficeFlagIcon16Regular,
        solid: BuildingOfficeFlagIcon16Solid,
    },
    20: {
        light: BuildingOfficeFlagIcon20Light,
        regular: BuildingOfficeFlagIcon20Regular,
        solid: BuildingOfficeFlagIcon20Solid,
    },
    24: {
        regular: BuildingOfficeFlagIcon24Regular,
        solid: BuildingOfficeFlagIcon24Solid,
    },
    32: {
        regular: BuildingOfficeFlagIcon32Regular,
    },
    64: {
        regular: BuildingOfficeFlagIcon64Regular,
    },
};
export var BuildingOfficeFlagIcon = forwardRef('BuildingOfficeFlagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
